export class Price {
  zoneId: number;
  id: number;
  weight: number;
  amount: number;
  description: string;
  active: boolean;
  createdBy: string;
  createdDate: Date;
  lastModifiedBy: string;
  lastModifiedDate: Date;
}
